import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'router-outlet-loading',
    templateUrl: './router-outlet-loading.component.html',
    styleUrls: ['./router-outlet-loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouterOutletLoadingComponent {
    get activatedUrl() {
        return this.activatedRoute.pathFromRoot
            .map(x => x.snapshot.url)
            .flat()
            .map(x => x.toString())
            .join('/');
    }

    constructor(private activatedRoute: ActivatedRoute) {}
}
